import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { useTranslation } from 'react-i18next'

// VH-227: clearing the chat deletes messages only; proposals and confirmed changes stay.
export function ClearChatDialog({ open, onClose, onConfirm, busy = false, error = null }) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[60]">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-md rounded-xl bg-surface-container p-6 shadow-xl">
          <DialogTitle className="text-lg font-semibold text-gray-900">{t('healthCycle.chat.clearTitle')}</DialogTitle>
          <p className="mt-3 text-sm text-gray-700">{t('healthCycle.chat.clearWarning')}</p>
          {error && <p className="mt-3 text-sm text-red-600" role="alert">{error}</p>}
          <div className="mt-6 flex justify-end gap-2">
            <button type="button" className="btn-outline text-sm" onClick={onClose}>{t('common.cancel')}</button>
            <button type="button" className="btn-danger text-sm" disabled={busy} onClick={onConfirm}>
              {t('healthCycle.chat.clearConfirm')}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}

export default ClearChatDialog
